import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentUser } from '../app/model/current-user';

@Injectable()
export class ExpiryGuard  {

    currentUser: CurrentUser;
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.currentUser = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
        if (this.currentUser.expireDays <= 0) {
            this.router.navigate(['../app/stoda/license-expiry']);
            return true;
        }
        return true;
    }
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }
    canLoad(route: Route): boolean {

        this.currentUser = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
        if (this.currentUser.expireDays <= 0) {
            this.router.navigate(['../app/stoda/license-expiry']);
            return true;
        }
        return true;    }
    constructor(private router: Router) {
    }

}
